import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const propertySchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  measure_id: required({ t })(Yup.string()),
  main_cultures: required({ t })(Yup.string()),
  state: required({ t })(Yup.string()),
  city: required({ t })(Yup.string()),
  country: required({ t })(Yup.string()),
  lat: Yup.string(),
  lon: Yup.string()
})

export default propertySchema
